(function () {
  const PATH_COLLAPSED =
    'M68.4915 0.0500873C73.326 0.0483359 77.4301 3.43357 77.843 7.7667L77.879 11.0169L78.7932 11.0166L78.8263 7.77774C79.2363 3.43292 83.0863 0.0448478 87.5896 0.0431624L119.557 0.0315697C124.048 0.0299774 127.352 3.1304 127.788 7.74858L127.824 10.9987L128.75 10.9984L128.772 7.74823C129.09 3.20958 131.969 0.0384248 135.775 0.0370434L170.336 0.0245112C174.108 0.0232117 176.795 2.98709 177.185 7.58252L177.22 10.8326L178.146 10.8323L178.18 7.58216C178.487 3.35133 182.108 0.0315955 186.406 0.0300371L219.322 0.0181009C223.95 0.0164422 227.517 3.19663 227.976 7.74635L228.011 10.9851L228.915 10.9848L228.959 7.75792C229.552 2.97965 232.762 0.0133027 237.345 0.011564L269.633 -0.000144495L269.632 0.0112116C274.433 0.00946994 278.183 3.89691 278.185 8.86888L278.195 36.0661L261.371 36.0722L261.368 28.5117L257.848 28.513L257.791 28.8555C257.038 33.1775 253.816 36.075 249.77 36.0764L237.416 36.0809C235.976 36.0814 234.604 35.7059 233.392 35.0563C230.592 33.552 228.91 30.5535 228.909 27.372L228.909 25.9348L228.086 25.9351L228.09 36.0729L209.209 36.0798L209.201 14.8923L196.971 14.8967L196.979 36.0842L177.813 36.0912L177.809 27.1168L176.986 27.1171L176.994 48.2024C176.997 54.5426 173.307 58.0331 166.598 58.0355L136.002 58.0464L135.997 43.9064L162.078 43.8969L162.075 36.0968L135.788 36.1064C132.325 36.1077 129.353 33.4974 128.883 30.031L128.882 27.1573L128.059 27.1576L128.062 36.0978L112.187 36.1036L112.184 28.5431L108.664 28.5444L108.607 28.8862C107.866 33.2085 104.632 36.1063 100.586 36.1078L87.5912 36.1125C86.2773 36.113 85.0084 35.8056 83.8767 35.2587C80.8817 33.823 79.0405 30.7102 79.0392 27.3803L79.0385 25.9778L78.2157 25.9781L78.2196 36.1159L59.0075 36.1229L58.9996 14.9349L46.7699 14.9393L46.7778 36.1273L31.2342 36.1329L31.2263 14.9449L18.9974 14.9494L19.0053 36.1374L0.0100408 36.1443L-3.30228e-05 8.93568C-0.00184015 4.05499 3.91682 0.0735586 8.75128 0.0717548L68.4915 0.0500873ZM90.8516 13.4299L90.8547 21.0472L113.439 21.039L113.436 13.4218L90.8516 13.4299ZM140.945 13.4118L140.948 21.029L163.532 21.0208L163.53 13.4036L140.945 13.4118ZM240.242 13.3758L240.245 20.993L262.828 20.9848L262.825 13.3676L240.242 13.3758Z'

  const PATH_EXPANDED =
    'M68.4916 0.049864C73.326 0.0481125 77.6184 3.43334 78.0313 7.76647L78.0313 18.9951L81.1268 18.995L81.1268 7.77732C81.5368 3.4325 85.2969 0.0444286 89.8002 0.0427432L121.767 0.0311505C126.259 0.0295582 129.7 3.12998 130.136 7.74816L130.136 18.995L133.238 18.9951L133.238 7.74765C133.556 3.20901 136.391 0.0388785 140.196 0.0374971L174.758 0.0249649C178.529 0.0236654 181.134 2.98754 181.525 7.58297L181.525 18.9951L184.627 18.9952L184.627 7.58246C184.934 3.35163 188.741 0.031897 193.038 0.0303385L225.954 0.0184022C230.582 0.0167435 234.207 3.19693 234.665 7.74665L234.665 18.9952L237.777 18.9953L237.777 7.75806C238.369 2.9798 241.605 0.0134516 246.188 0.011713L278.476 4.22598e-06L278.476 0.0113603C283.276 0.00961866 287.026 3.89706 287.028 8.86903L287.038 36.0662L270.214 36.0723L270.211 28.5119L266.691 28.5132L266.634 28.8556C265.881 33.1777 262.659 36.0751 258.613 36.0765L246.259 36.081C244.819 36.0815 243.447 35.706 242.235 35.0565C239.435 33.5522 237.778 30.5536 237.777 27.3721L237.777 18.9953L234.665 18.9952L234.665 36.0732L215.841 36.0801L215.833 14.8926L203.604 14.897L203.612 36.0845L184.627 36.0915L184.627 18.9952L181.525 18.9951L181.525 48.2028C181.527 54.5431 177.728 58.0335 171.019 58.036L140.423 58.0469L140.418 43.9068L166.499 43.8974L166.496 36.0973L140.209 36.1069C136.747 36.1081 133.708 33.4979 133.238 30.0315L133.238 18.9951L130.136 18.995L130.136 36.0974L114.397 36.1032L114.394 28.5427L110.875 28.544L110.818 28.8858C110.076 33.208 106.843 36.1059 102.797 36.1074L89.8018 36.1121C88.4879 36.1126 87.219 35.8052 86.0873 35.2583C83.0923 33.8226 81.1281 30.7098 81.1268 27.3799L81.1268 18.995L78.0313 18.9951L78.0313 36.1158L59.0075 36.1227L58.9997 14.9346L46.77 14.939L46.7779 36.1271L31.2343 36.1327L31.2264 14.9447L18.9975 14.9491L19.0053 36.1372L0.0101084 36.1441L3.45767e-05 8.93545C-0.00177255 4.05476 3.91688 0.073335 8.75135 0.0715313L68.4916 0.049864ZM93.0622 13.4295L93.0653 21.0468L115.65 21.0386L115.647 13.4213L93.0622 13.4295ZM145.367 13.4122L145.369 21.0294L167.954 21.0213L167.951 13.404L145.367 13.4122ZM249.085 13.3759L249.088 20.9931L271.671 20.985L271.668 13.3677L249.085 13.3759Z'

  const DURATION = 1000

  function parseTokens(d) {
    return d.match(
      /[MmCcLlZzHhVvSsQqTtAa]|[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?/g,
    )
  }

  function easeInOut(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
  }

  function lerpTokens(tokensA, tokensB, t) {
    return tokensA.map(function (a, i) {
      var numA = parseFloat(a)
      if (isNaN(numA)) return a
      return parseFloat(
        (numA + (parseFloat(tokensB[i]) - numA) * t).toFixed(4),
      ).toString()
    })
  }

  function getPathBBox(svgEl, d) {
    var tmp = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    tmp.setAttribute('d', d)
    tmp.style.visibility = 'hidden'
    svgEl.appendChild(tmp)
    var bb = tmp.getBBox()
    tmp.remove()
    return bb
  }

  function initMorph(container) {
    var svgEl = container.querySelector('.js-morph-svg')
    var morphEl = container.querySelector('.js-morph-path')
    if (!svgEl || !morphEl) return

    var gEl = document.createElementNS('http://www.w3.org/2000/svg', 'g')
    morphEl.remove()
    svgEl.appendChild(gEl)
    gEl.appendChild(morphEl)

    var tokensA = parseTokens(PATH_COLLAPSED)
    var tokensB = parseTokens(PATH_EXPANDED)

    var bb1 = getPathBBox(svgEl, PATH_COLLAPSED)
    var bb2 = getPathBBox(svgEl, PATH_EXPANDED)

    var targetX = (-1 + 289) / 2
    var targetY = (-1 + 62) / 2

    var startExpanded = container.dataset.morphStart === 'expanded'
    var initialT = startExpanded ? 1 : 0

    var animFrame = null
    var startTime = null
    var currentT = initialT
    var fromT = initialT
    var toT = 0

    function renderFrame(t) {
      var tokens = lerpTokens(tokensA, tokensB, t)
      morphEl.setAttribute('d', tokens.join(' '))

      var bb = getPathBBox(svgEl, tokens.join(' '))
      var cx = bb.x + bb.width / 2
      var cy = bb.y + bb.height / 2
      gEl.setAttribute(
        'transform',
        'translate(' + (targetX - cx) + ', ' + (targetY - cy) + ')',
      )
    }

    renderFrame(initialT)

    function animate(timestamp) {
      if (!startTime) startTime = timestamp
      var elapsed = timestamp - startTime
      var progress = Math.min(elapsed / DURATION, 1)
      currentT = fromT + (toT - fromT) * easeInOut(progress)
      renderFrame(currentT)
      if (progress < 1) {
        animFrame = requestAnimationFrame(animate)
      } else {
        fromT = toT
        animFrame = null
        startTime = null
      }
    }

    function startAnim(target) {
      if (animFrame) {
        cancelAnimationFrame(animFrame)
        animFrame = null
      }
      fromT = currentT
      toT = target
      startTime = null
      animFrame = requestAnimationFrame(animate)
    }

    if (!startExpanded) {
      container.addEventListener('mouseenter', function () {
        startAnim(1)
      })
      container.addEventListener('mouseleave', function () {
        startAnim(0)
      })
    }
  }

  document.querySelectorAll('.js-morph-logo').forEach(initMorph)
})()
